import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";

export const leaderboardApi = createApi({
  reducerPath: "leaderboard",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Leaderboard"],
  endpoints: (builder) => ({
    getLeaderboard: builder.query({
      query: ({ period, role, teamId, startDate, endDate, limit = 50 }) => ({
        url: "leaderboard",
        params: {
          period,
          role,
          teamId: teamId || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
          limit,
        },
      }),
      providesTags: ["Leaderboard"],
      keepUnusedDataFor: 60,
    }),
  }),
});

export const { useGetLeaderboardQuery } = leaderboardApi;
